import {
  GridSortProps,
  IOrderClause,
  ListViewGridColumnGeneratorParams,
  OrderBy
} from '@tableau/data-catalog-shared';
import { OrderDirection } from '../../../gen-src/queries/globalTypes';

export type GlobalAssetGridDC3ColumnFactoryParams<OrderFields extends string> =
  Partial<GridSortProps<OrderFields>>;

export function makeDC3ColumnFactoryParamsFromVizPortalParams<OrderFields extends string>(
  vizPortalColumnParams: ListViewGridColumnGeneratorParams
): GlobalAssetGridDC3ColumnFactoryParams<OrderFields> {
  const orderBy = orderClausesToOrderBy<OrderFields>(vizPortalColumnParams.currentSort);

  // VizPortal uses lowercase order params, so as we send the sort field to the VizPortal infrastructure,
  // make it lowercase to match the order fields as VizPortal expects to find them.
  const updateSortOrder = (field: string) => vizPortalColumnParams.changeSort(field.toLowerCase());

  if (orderBy) {
    return { orderBy, updateSortOrder };
  } else {
    return {};
  }
}

/**
 * Converts an OrderClauses array (from VizPortal) to an OrderBy (for DC3).
 * We do this conversion in one layer where we need compatibility with VizPortal's types.
 */
export function orderClausesToOrderBy<OrderFields extends string>(
  orderClauses: ReadonlyArray<IOrderClause> | undefined
): OrderBy<OrderFields> | undefined {

  const orderClause = orderClauses && orderClauses[0];
  if (!orderClause) {
    return undefined;
  }

  return {
    field: orderClause.field as OrderFields,
    direction: orderClause.ascending ? OrderDirection.ASC : OrderDirection.DESC
  };
}
